import {
  XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
 Bar,BarChart,
} from "recharts";
import CountUp from 'react-countup';
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


export default function TrainingDashboard() {
  
  const data = {
    title: "Dereja Academy Accelerated Program",
    
    stats: {
      university: 70,
      tots: 82,
      TotalTrained: 9593,
      employed: 3171,
      selfEmployed: 336,
      Enrolled:25000
    },
  
    yearlyAchievements: [
      { year: 2020, Target: 1000, Achievement: 500 },
      { year: 2021, Target: 1500, Achievement: 302 },
      { year: 2022, Target: 2000, Achievement: 799 },
      { year: 2023, Target: 2500, Achievement: 2628 },
      { year: 2024, Target: 3000, Achievement: 3926},
      { year: 2025, Target: 0, Achievement: 1438},
    ],
    
    genderDistribution: [
      { name: "Male", value: 60 },
      { name: "Female", value: 22}
    ],
    
    placementData: [
      { name: "Employed", value: 2987 },
      { name: "Self-Employed", value:336 }
    ]
  };

const dataa = [
  { category: 'Employed', male: 1930, female: 1220, total: 3150 },
  { category: 'Self-Employed', male: 278, female: 79, total: 357},
];
 

  const COLORS = {
    primary: '#FE5D26',
    secondary: '#FF9B45',
    accent: '#E52020',
    light: '#FFC107',
    dark: '#333333'
  };
const universities = [
    {
      name: 'Addis Ababa University',
      description: '23 ToT,1091+ trainees'
    },
    {
      name: 'Hawassa University',
      description: '40 ToT,1054+ trainees'
    },
    {
      name: 'Arbaminch University',
      description: '22 ToT,816+ trainees'
    },
    {
      name: 'Jimma University',
      description: '25 ToT,608+ trainees'
    },
    
    {
      name: 'Haramaya University',
      description: '26 ToT,518+ trainees'
    },
  ];

  const [expandedIndex, setExpandedIndex] = useState(null);
  return (
    <div className="min-h-screen bg-gray-50 px-6 py-8">
     
      <div className="mb-8 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">{data.title}</h1>
        <p className="text-gray-600">Comprehensive overview of training programs and outcomes</p>
      </div>

      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
       
        <div 
          className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FE5D26]"
          data-tooltip-id="university-tooltip"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Training Of Trainers</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.tots} duration={2} />
              </h3>
              
            </div>
           <div className="flex flex-col items-center justify-center">
      <div className="bg-[#FFE9E1] p-3 rounded-full">
         <svg className="w-6 h-6 text-[#E52020]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
       
      </div>
      <p className="text-[13px] font-semibold text-orange-600 mt-2">27% Female</p>
    </div>
  </div>
          
 

           </div>
          
          <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#E52020]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">University Involved</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.university} duration={2} />+
              </h3>
            </div>
            <div className="bg-[#FFE5E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FE5D26]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
            </div>
            
          </div>
           <p className="text-[13px] font-semibold text-orange-600 mt-2">29 Partner universities & 50 Non-partner Universities. </p>
        </div>

        {/* Total Trained */}
        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FF9B45]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Total Candidates Trained</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.TotalTrained} duration={2} separator="," />
              </h3>
               <p className="text-[13px] font-semibold text-orange-600 mt-2">1% PWD</p>
            </div>
             
           <div className="flex flex-col items-center">
             
         <div className="bg-[#FFF0E5] p-3 rounded-full">
    <svg className="w-6 h-6 text-[#FF9B45]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
    </svg>
  </div>
  <p className="text-[13px] font-semibold text-orange-600 mt-2">31% Female</p>
</div>
          </div>
        </div>
 

        {/* Total Placed */}
        <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all border-l-4 border-[#FFC107]">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-500">Placement of DAAP</p>
              <h3 className="text-2xl font-bold text-gray-800 mt-1">
                <CountUp end={data.stats.employed + data.stats.selfEmployed} duration={2} separator="," />
              </h3>
            </div>
            <div className="flex flex-col items-center">
            <div className="bg-[#FFF8E5] p-3 rounded-full">
              <svg className="w-6 h-6 text-[#FFC107]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
             <p className="text-[13px] font-semibold text-orange-600 mt-2">37% Female</p>
            </div>
          </div>
        </div>
      </div>


<div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">

 
  <div className="bg-white p-6 rounded-xl shadow-md space-y-8">
    <div>
      <h3 className="text-md font-semibold text-gray-800 mb-4">
        Top 5 Universities Based On Number Of Trainees
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-h-80 overflow-y-auto pr-2">
        {universities.map((uni, index) => (
          <div
            key={index}
            onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
            className={`cursor-pointer rounded-2xl p-5 shadow-lg border transition-all duration-300 ${
              expandedIndex === index
                ? 'bg-orange-100 border-orange-400'
                : 'bg-white hover:shadow-xl'
            }`}
          >
            <div className="flex justify-between items-center">
              <h4 className="text-sm font-bold text-gray-800">{uni.name}</h4>
              <span className="text-orange-500 text-lg">
                {expandedIndex === index ? '▲' : '▼'}
              </span>
            </div>
            {expandedIndex === index && (
              <p className="mt-3 text-sm text-gray-600">
                <br />
                {uni.description}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  </div>


  <div className="relative group">
    <div className="bg-white p-6 rounded-xl shadow-md transition duration-300 group-hover:shadow-lg">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Yearly Target Vs Achievement 
      </h3>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data.yearlyAchievements} barGap={8}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis dataKey="year" stroke="#666" />
            <YAxis stroke="#666" />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgb(250, 216, 216)',
                border: 'none',
              }}
            />
            <Legend />
            <Bar
              dataKey="Target"
              fill={COLORS?.primary || "#8884d8"}
              name="Target"
            />
            <Bar
              dataKey="Achievement"
              fill={COLORS?.secondary || "#82ca9d"}
              name="Achievement"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>

   
  </div>
  
<div className="bg-white p-6 rounded-xl shadow-md">
  <h3 className="text-lg font-semibold text-gray-800 mb-4">Placement Breakdown</h3>
  <div className="h-80">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart 
        data={dataa} 
        barGap={8}
        margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
        <XAxis 
          dataKey="category" 
          tickLine={false} 
          axisLine={{ stroke: '#E5E7EB' }} 
          tick={{ fill: '#6B7280', fontSize: 12 }}
          padding={{ left: 20, right: 20 }}
        />
        <YAxis 
          axisLine={{ stroke: '#E5E7EB' }} 
          tickLine={false}
          tick={{ fill: '#6B7280', fontSize: 12 }}
          domain={[0, 100]}
          tickFormatter={(value) => `${value}`}
        />
        <Tooltip 
          formatter={(value, name) => [`${value}`, 
            {male: 'Male', female: 'Female', total: 'Total'}[name]
          ]}
          contentStyle={{
            background: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}
          labelFormatter={(label) => `Category: ${label}`}
          labelStyle={{ fontWeight: 500, color: '#111827' }}
        />
        <Bar 
          name="Total" 
          dataKey="total" 
          fill="#8BC34A" 
          barSize={24} 
          radius={[4, 4, 0, 0]} 
        />
        <Bar 
          name="Male" 
          dataKey="male" 
          fill="#4A90E2" 
          barSize={24} 
          radius={[4, 4, 0, 0]} 
        />
        <Bar 
          name="Female" 
          dataKey="female" 
          fill="#FF9B45" 
          barSize={24} 
          radius={[4, 4, 0, 0]} 
        /> 
        <Legend 
          verticalAlign="top" 
          iconType="circle" 
          wrapperStyle={{ paddingBottom: '20px' }}
          formatter={(value) => (
            <span className="text-sm text-gray-600">{value}</span>
          )}
        />
      </BarChart>
    </ResponsiveContainer>
  </div>
</div>
      </div>

 <div className="bg-white p-2 rounded-xl shadow-md mb-8">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">DAAP Training Pre-Post Impact Overview </h3>
     <div className="mt-6 p-4 bg-gray-50 rounded-lg">
      <p className="text-gray-700 italic"> 
        <div className="mt-3 p-4 bg-gray-50 rounded-lg">
      <p className="text-gray-700 italic">"This insight showcases significant improvements in DAAP from the pre- and post-survey assessments conducted on 1177 trainee's  of 2024.These findings highlight the program's effectiveness in enhancing participants' skills and readiness for the job market."</p>
    </div></p>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-3 gap-1 text-center">
      <div className="p-2">
        <div className="text-3xl font-bold text-[#FE5D26]">77.3% → 83.85%</div>
        <p className="text-sm text-gray-600 mt-2">Understanding about different aspects of self-awareness.</p>
      </div>
      <div className="p-2">
        <div className="text-3xl font-bold text-[#FF9B45]">66.95% → 85.42%</div>
        <p className="text-sm text-gray-600 mt-2">Setting personal & professional goals.</p>
      </div>
      <div className="p-2">
        <div className="text-3xl font-bold text-[#4A90E2]">64.6% → 83.6%</div>
        <p className="text-sm text-gray-600 mt-2">Email and report writing skill.</p>
      </div>
      <div className="p-2">
        <div className="text-3xl font-bold text-[#8BC34A]">60% → 96.6%</div>
        <p className="text-sm text-gray-600 mt-2">Having current and up-to-date resume and cover letter.</p>
      </div>
    </div>
  </div>
    
  <div className="mt-6">
  <h4 className="text-md font-semibold text-gray-700 mb-2">Highlights from the Program</h4>
  <Slider
    dots={false}
    infinite={true}
    speed={500}
    slidesToShow={3}
    slidesToScroll={1}
    autoplay={true}
    autoplaySpeed={3000}
    arrows={false}
    className="mx-4"
  >
    {[
      "/assets/daap1.jpg",
      "/assets/daap1.jpg",
      "/assets/daap3.jpg",
      "/assets/daap4.jpg",
    ].map((src, index) => (
      <div key={index} className="px-2">
        <img
          src={src}
          alt={`Slide ${index + 1}`}
          className="rounded-lg shadow-md h-40 w-full object-cover"
        />
      </div>
    ))}
  </Slider>
</div>

    </div>
    
  );
}